/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdCommonModule} from '@angular/material/core';
import {
  MdProgressSpinner,
  MdSpinner,
  MdProgressSpinnerCssMatStyler,
} from './progress-spinner';
export class MdProgressSpinnerModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdCommonModule],
  exports: [
    MdProgressSpinner,
    MdSpinner,
    MdCommonModule,
    MdProgressSpinnerCssMatStyler
  ],
  declarations: [
    MdProgressSpinner,
    MdSpinner,
    MdProgressSpinnerCssMatStyler
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdProgressSpinnerModule_tsickle_Closure_declarations() {
/** @type {?} */
MdProgressSpinnerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdProgressSpinnerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
